import { Controller } from "@hotwired/stimulus"
import {
  Chart,
  LineController,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js"

Chart.register(LineController, LineElement, PointElement, CategoryScale, LinearScale, Tooltip, Legend)

// One indicator over the years, one line per country (two in compare mode).
//
// data-controller="trend-chart"
// data-trend-chart-labels-value="[2022, 2023, ...]"
// data-trend-chart-series-value='[{"label": "Nigeria", "data": [1, null, 3], "color": "#00558A"}, ...]'
// data-trend-chart-unit-value="kWp"
export default class extends Controller {
  static targets = ["canvas"]
  static values  = {
    labels: Array,
    series: Array,
    unit:   String,
  }

  connect() {
    const unit = this.unitValue
    const fmt  = (v) => (v == null ? "-" : `${v.toLocaleString(undefined, { maximumFractionDigits: 2 })}${unit ? ` ${unit}` : ""}`)

    this.chart = new Chart(this.canvasTarget.getContext("2d"), {
      type: "line",
      data: {
        labels: this.labelsValue,
        datasets: this.seriesValue.map((s) => ({
          label:                s.label,
          data:                 s.data,
          borderColor:          s.color,
          backgroundColor:      s.color,
          pointRadius:          3,
          pointHoverRadius:     5,
          borderWidth:          2,
          tension:              0.25,
          spanGaps:             false, // a year without snapshots stays a gap, not a fake trend
        })),
      },
      options: {
        responsive:          true,
        maintainAspectRatio: false,
        interaction:         { mode: "index", intersect: false },
        plugins: {
          legend:  { display: this.seriesValue.length > 1, position: "bottom", labels: { boxWidth: 10, font: { size: 11 } } },
          tooltip: { callbacks: { label: (ctx) => `${ctx.dataset.label}: ${fmt(ctx.parsed.y)}` } },
        },
        scales: {
          x: { grid: { display: false }, ticks: { font: { size: 11 } } },
          y: { beginAtZero: true, ticks: { font: { size: 11 }, callback: (v) => Number(v).toLocaleString() } },
        },
      },
    })
  }

  disconnect() {
    this.chart?.destroy()
  }
}
